import { auth } from '../firebase';
import { getDeviceFingerprint } from './deviceFingerprint';
import { getUserDevice } from './firebaseService';

export const validateSession = async (user) => {
  try {
    // Get user role from token
    const tokenResult = await user.getIdTokenResult();
    const role = tokenResult.claims.role;

    // For users, verify device
    if (role === 'user') {
      const currentDeviceId = await getDeviceFingerprint();
      const userDevice = await getUserDevice(user.uid);

      if (!userDevice?.deviceId || userDevice.deviceId !== currentDeviceId) {
        return false;
      }
    }

    // Check token age and refresh if needed
    const tokenAge = new Date().getTime() / 1000 - tokenResult.claims.auth_time;
    if (tokenAge > 3600) {
      await user.getIdToken(true);
    }

    return true;
  } catch (error) {
    console.error('Error validating session:', error);
    return false;
  }
};

export const setupAuthPersistence = async () => {
  try {
    await auth.setPersistence('local');
    return true;
  } catch (error) {
    console.error('Error setting up auth persistence:', error);
    return false;
  }
}; 